import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import Image from "next/image";
import { HiArrowRight } from "react-icons/hi";

function BlackButton({ text, onClick, className, icon }) {
    return (
        <motion.button
            type="button"
            onTap={onClick}
            className={cn(
                `select-none rounded-full font-Inter bg-black text-[#FFFFFF] shadow-md border lg:border-2 border-white ${
                    className ?? "px-6 lg:px-8 py-2 lg:py-4 text-sm lg:text-xl font-extrabold lg:font-semibold "
                }`
            )}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            {icon ? <HiArrowRight size={30} /> : text}
        </motion.button>
    );
}

function DynamicButton({ text, onClick, className, disabled }) {
    return (
        <motion.button
            disabled={disabled}
            type="button"
            onTap={onClick}
            className={` select-none font-Inter  disabled:bg-[#9D9D9D] ${
                className ?? " max-w-fit text-sm font-semibold rounded-lg px-6 py-2 "
            }`}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            {text}
        </motion.button>
    );
}

function ScreenerCategoryChip({ text, onClick, className }) {
    return (
        <motion.button
            onTap={onClick}
            className={`select-none px-4 whitespace-nowrap py-2 rounded-lg font-Inter text-[12px] lg:text-sm border font-extrabold shadow-md ${
                className ?? " bg-white border-primary text-primary"
            }`}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            {text?.length > 20 ? text?.slice(0, 18) + "..." : text}
        </motion.button>
    );
}

function NewsCategoryChip({ text, onClick, icon }) {
    return (
        <motion.button
            onTap={onClick}
            className={`select-none px-5 flex items-center py-2 rounded-full font-Inter text-[12px] lg:text-sm border bg-white border-primary text-black font-semibold shadow`}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            <Image src={icon} className="mr-2 h-[20px] w-[20px]" width={20} height={20} alt="icon" />
            {text}
        </motion.button>
    );
}

function IconTextBtn({ text, textClass, onClick, icon, iconClass }) {
    return (
        <motion.button
            onTap={onClick}
            className={`select-none flex items-center font-Inter border ${
                textClass ??
                "px-5  py-2 rounded-full text-[12px] lg:text-sm bg-white border-primary text-black font-semibold shadow"
            }`}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            <Image src={icon} className={iconClass ?? "mr-2 h-[20px] w-[20px]"} width={20} height={20} alt="icon" />
            {text}
        </motion.button>
    );
}

function IconBtn(props) {
    return (
        <motion.button
            id={props.id}
            className={props.className}
            onTap={props.onClick}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            {props.children}
        </motion.button>
    );
}

function ResultButton({ active, text, onClick, className }) {
    return (
        <motion.button
            type="button"
            onTap={onClick}
            className={`select-none px-4 lg:px-7 py-1 text-xs lg:text-lg rounded-full font-Inter text-[#FFFFFF] shadow-md border lg:border-2  ${
                active ? "text-white bg-[#1684FD] border-white" : " text-black bg-white border-[#F5F5F5]"
            } ${className}`}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            {text}
        </motion.button>
    );
}

function ExploreMore({ onClick, className }) {
    return (
        <motion.button
            type="button"
            onTap={onClick}
            className={`flex items-center text-sm lg:text-base font-semibold text-black border-2 border-black rounded-full px-4 py-1.5 ${className}`}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
            Explore more
            <HiArrowRight size={16} className="ml-2" />
        </motion.button>
    );
}

function TabBar(props) {
    return (
        <button
            id={props.id}
            onClick={props.onClick}
            className={`w-full px-4 py-2.5 border-b-4 outline-0 font-Inter text-[14px] ease-in duration-300 ${
                props.className
            } ${
                props.active ? " border-b-[#00439D] text-[#00439D] font-semibold " : " border-b-[#E5E5E5] font-medium"
            }`}
        >
            {props.text}
            {props.children}
        </button>
    );
}

function TransparentCardTitleBtn({ active, text, onClick, className }) {
    return (
        <button
            id={active ? "screenerActive" : ""}
            onClick={onClick}
            className={cn(
                `rounded-[19px] px-3 lg:px-4 py-1 mr-3 whitespace-nowrap z-[3] text-[10px] leading-[16px] tracking-[.5px] lg:text-sm 
                ${
                    active
                        ? "text-white font-semibold bg-black"
                        : "font-medium bg-[#FFFFFF] border-[1px] border-[#747474] text-[#747474]"
                }`,
                className
            )}
        >
            {text}
        </button>
    );
}

function FIIDIIBtn({ active, text, onClick }) {
    return (
        <button
            onClick={onClick}
            className={`rounded-full px-3 py-1 ml-3 whitespace-nowrap text-[10px] leading-[16px] tracking-[.5px] ${
                active
                    ? "text-[#00439D] font-semibold border-[#00439D] border-[1px] bg-[#ECF6FE]"
                    : "font-medium bg-[#FFFFFF] border-[1px] border-[#9D9D9D] text-[#9D9D9D]"
            }`}
        >
            {text}
        </button>
    );
}

function BlackButtonNew({ text, onClick, className, icon, id = " ", disabled = false }) {
    return (
        <motion.button
            id={id}
            type="button"
            onTap={!disabled ? onClick : null} // Only trigger onClick if not disabled
            className={`flex justify-center items-center gap-[12.5px] flex-[1_0_0] px-3 py-1 rounded-[20px] select-none font-Inter ${
                disabled
                    ? "bg-gray-400 text-white cursor-not-allowed" // Gray background for disabled
                    : className ?? "bg-black text-white cursor-pointer" // Black background when enabled
            }`}
            whileTap={!disabled ? { scale: 0.95 } : {}} // Only allow scaling when enabled
            whileHover={!disabled ? { scale: 1.05 } : {}} // Only allow scaling when enabled
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
            disabled={disabled} // Set the disabled attribute
        >
            {icon ? <HiArrowRight size={30} /> : text}
        </motion.button>
    );
}

function CardTitleBtn({ active, text, onClick }) {
    return (
        <motion.button
            onClick={onClick}
            className={`rounded-full px-3 py-1 whitespace-nowrap text-[10px] leading-4 font-medium lg:text-xs ${
                active
                    ? " text-[#00439D] outline-none font-semibold snap-center flex flex-col justify-center items-center gap-1 border-[#0862BC] bg-[#ECF6FE] rounded-[32px] border-[1.5px] border-solid"
                    : "font-medium flex flex-col justify-center items-center gap-1 border border-[#9D9D9D] bg-[#FFF] rounded-[32px] border-solid"
            }`}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
            {text}
        </motion.button>
    );
}

function DurationBtn({ active, text, onClick }) {
    return (
        <button
            onClick={onClick}
            className={`my-1 w-full py-1 rounded text-[10px] leading-4 lg:text-xs tracking-[.5px] border ${
                active
                    ? "text-primary border-primary bg-[#ECF6FE] font-bold"
                    : "text-[#202020] border border-[#9D9D9D] font-medium"
            }`}
        >
            {text}
        </button>
    );
}

function CardTitleBtnSmall({ active, text, onClick }) {
    return (
        <motion.button
            onClick={onClick}
            className={`w-fit min-w-[60px] lg:min-w-[92px] rounded-full px-1 py-1 whitespace-nowrap text-[10px] lg:text-sm font-medium leading-4 ${
                active
                    ? " text-[#00439D] outline-none font-semibold snap-center flex flex-col justify-center items-center gap-1 border-[#0862BC] bg-[#ECF6FE] px-2 py-1 rounded-[32px] border-[1.5px] border-solid"
                    : "font-medium flex flex-col justify-center items-center gap-1 border border-[#9D9D9D] bg-[#FFF] px-2 py-1 rounded-[32px] border-solid"
            }`}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
            {text}
        </motion.button>
    );
}

function FAQCatBtn({ active, text, onClick, className }) {
    return (
        <motion.button
            onClick={onClick}
            className={`rounded-[19px] lg:text-base text-[10px] px-3 py-1 mr-3 mt-4 mb-2 whitespace-nowrap ${
                active
                    ? " bg-[#EFF6FF] text-[#00439D] outline-none font-semibold snap-center"
                    : "font-medium text-[#9D9D9D] border"
            } ${className}`}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
            {text}
        </motion.button>
    );
}

export {
    TabBar,
    FIIDIIBtn,
    TransparentCardTitleBtn,
    NewsCategoryChip,
    ScreenerCategoryChip,
    IconBtn,
    BlackButton,
    DynamicButton,
    BlackButtonNew,
    IconTextBtn,
    ResultButton,
    ExploreMore,
    CardTitleBtn,
    DurationBtn,
    CardTitleBtnSmall,
    FAQCatBtn
};
